/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import useServiceFactory from "../../api/serviceFactory";

export default function useOfflineApi() {
  const service = useServiceFactory({
    uri: process.env.REACT_APP_API_URL,
  });

  const storageKey = "apiCalls";

  const updateStorage = (newList) => {
    window.localStorage.setItem(
      storageKey,
      JSON.stringify(newList),
    );
  };

  const getFromStorage = () => {
    const item = window.localStorage.getItem(storageKey);

    if (
      item == null ||
      item.trim() === "" ||
      item === "null"
    ) {
      return [];
    }

    try {
      return JSON.parse(item);
    } catch {
      return [];
    }
  };

  const agregarPendiente = (
    entity,
    apiUrl,
    count,
  ) => {
    const pendientes = getFromStorage();

    const yaExiste = pendientes.some(
      (item) =>
        item.apiUrl === apiUrl &&
        JSON.stringify(item.entity) ===
          JSON.stringify(entity),
    );

    if (yaExiste) {
      return;
    }

    updateStorage([
      ...pendientes,
      {
        entity,
        apiUrl,
        count,
      },
    ]);
  };

const pushCall = async (
  entity,
  apiUrl,
  count = 0,
  showLoading = true,
) => {
  try {
    const response = await service.post(
      apiUrl,
      entity,
      {
        showLoading,
        showSuccess: false,
        ignoreError: true,
      },
    );

    if (response?.error) {
      const mensaje =
        response?.data?.errorMessage ||
        response?.data?.ErrorMessage ||
        response?.error?.message ||
        response?.message ||
        `No se pudo guardar la solicitud${
          response?.status
            ? ` (HTTP ${response.status})`
            : ""
        }.`;

      throw new Error(mensaje);
    }

    return response;
  } catch (error) {
    const esErrorDeRed =
      error?.message === "Network Error";

    if (esErrorDeRed && count < 2) {
      agregarPendiente(
        entity,
        apiUrl,
        count + 1,
      );
    }

    throw error;
  }
};

  const retryCallApi = async () => {
    const pendientes = getFromStorage();

    if (pendientes.length === 0) {
      return;
    }

    const [nextCall, ...restantes] = pendientes;

    updateStorage(restantes);

    try {
      await pushCall(
        nextCall.entity,
        nextCall.apiUrl,
        nextCall.count ?? 0,
        false
      );
    } catch (error) {
      console.error(
        "No se pudo reenviar la solicitud pendiente:",
        error,
      );
    }
  };

  useEffect(() => {
    const interval = window.setInterval(() => {
      retryCallApi();
    }, 90000);

    return () => {
      window.clearInterval(interval);
    };
  }, []);

  return {
    pushCall,
  };
}